import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {ResidenceType} from 'features/search/filters/enums';
import {useSearchStore, selectResidenceType} from 'features/search/store/useSearchStore';
import {useShowPlotType, useShowSemiDetachedHouseType} from 'features/template/ViewModelProvider';

import {Icon} from 'components/atoms/Media/Icon';
import { Button, ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

export const ResidenceTypeButtons: React.FunctionComponent = ({}) => {
    const residenceType = useSearchStore(selectResidenceType);
    const updateFilters = useSearchStore(state => state.updateFilters);
    const showPlotType = useShowPlotType();
    const showSemiDetachedHouseType = useShowSemiDetachedHouseType();

    const onClick = (item: string) => (e: React.MouseEvent) => {
        e.preventDefault();

        const currentItems = [...residenceType];

        if (currentItems.filter((selected) => selected === item).length > 0) {
            const deleteIndex = currentItems.indexOf(item);

            currentItems.splice(deleteIndex, 1);
        } else {
            currentItems.push(item);
        }

        updateFilters({ residenceType: currentItems });
    };

    return (
        <div  className="residence-filter-form__section__grid">
            <Button
                onClick={onClick(ResidenceType.HOUSE)} 
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.SMALL}
                buttonType={residenceType.filter((selected) => selected === ResidenceType.HOUSE).length > 0
                    ? ButtonType.DEFAULT
                    : ButtonType.GHOST
                }
                icon={<Icon name="house" />}
            >
                <FormattedMessage id="jm.components.ResidenceTypeFilter.house" />
            </Button>
            <Button
                onClick={onClick(ResidenceType.APARTMENT)} 
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.SMALL}
                buttonType={residenceType.filter((selected) => selected === ResidenceType.APARTMENT).length > 0
                    ? ButtonType.DEFAULT
                    : ButtonType.GHOST
                }
                icon={<Icon name="appartment" />}
            >
                <FormattedMessage id="jm.components.ResidenceTypeFilter.apartment" />
            </Button>
            <Button
                onClick={onClick(ResidenceType.TOWN_HOUSE)} 
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.SMALL}
                buttonType={residenceType.filter((selected) => selected === ResidenceType.TOWN_HOUSE).length > 0
                    ? ButtonType.DEFAULT
                    : ButtonType.GHOST
                }
                icon={<Icon name="terraced" />}
            >
                <FormattedMessage id="jm.components.ResidenceTypeFilter.townHouse" />
            </Button>
            {showSemiDetachedHouseType && 
                <Button
                    onClick={onClick(ResidenceType.SEMI_DETACHED_HOUSE)} 
                    buttonColor={ButtonColor.DEFAULT} 
                    buttonSize={ButtonSize.SMALL}
                    buttonType={residenceType.filter((selected) => selected === ResidenceType.SEMI_DETACHED_HOUSE).length > 0
                        ? ButtonType.DEFAULT
                        : ButtonType.GHOST
                    }
                    icon={<Icon name="semi-detached-house" />}
                >
                    <FormattedMessage id="jm.components.ResidenceTypeFilter.semiDetachedHouse" />
                </Button>
            }
            {showPlotType && 
                <Button
                    onClick={onClick(ResidenceType.PLOT)} 
                    buttonColor={ButtonColor.DEFAULT} 
                    buttonSize={ButtonSize.SMALL}
                    buttonType={residenceType.filter((selected) => selected === ResidenceType.PLOT).length > 0
                        ? ButtonType.DEFAULT
                        : ButtonType.GHOST
                    }
                    icon={<Icon name="plot" />}
                >
                    <FormattedMessage id="jm.components.ResidenceTypeFilter.plot" />
                </Button>
            }
        </div>
    )
};
